// extracted by mini-css-extract-plugin
module.exports = {"MainLogin":"login_MainLogin__3OFa5","loginInput":"login_loginInput__1Ztlw","bottomtext":"login_bottomtext__yvHIS"};